export * from './manager.action';



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/store/actions/index.ts